// BE uses 10M for file size validation
// see https://symfony.com/doc/current/reference/constraints/File.html#maxsize
export const MAX_ATTACHMENT_FILE_SIZE = 10_000_000
